/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Remove trailing zeros from cart total prices
   * This function removes ",00" from prices like "€24,00" → "€24"
   * Only applies to cart drawer checkout button
   */
  function removeTrailingZerosFromPrice(priceString) {
    if (!priceString) return priceString;

    // Match patterns like "€24,00" or "$24.00" and remove the decimal zeros
    return priceString.replace(/([,.]00)(\s*\w{3})?$/g, '$2');
  }

  /**
   * Initialize cart total price formatter
   * Watches for changes to cart total and removes trailing zeros
   */
  function initCartTotalFormatter() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartTotalFormatter);
      return;
    }

    // Find all cart total price elements
    const cartTotalElements = document.querySelectorAll('[data-cart-total-price]');

    if (cartTotalElements.length === 0) {
      // If elements not found yet, try again after a short delay
      setTimeout(initCartTotalFormatter, 500);
      return;
    }

    // Process each cart total element
    cartTotalElements.forEach(element => {
      // Create observer to watch for changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const currentText = element.textContent.trim();
            const formattedText = removeTrailingZerosFromPrice(currentText);

            // Only update if the text actually changed
            if (currentText !== formattedText) {
              element.textContent = formattedText;
            }
          }
        });
      });

      // Start observing
      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });

      // Format initial content
      const initialText = element.textContent.trim();
      const formattedInitial = removeTrailingZerosFromPrice(initialText);
      if (initialText !== formattedInitial) {
        element.textContent = formattedInitial;
      }
    });

    // Also listen for cart update events to ensure we catch all updates
    document.addEventListener('theme:cart:update', function() {
      setTimeout(function() {
        const cartTotalElements = document.querySelectorAll('[data-cart-total-price]');
        cartTotalElements.forEach(element => {
          const currentText = element.textContent.trim();
          const formattedText = removeTrailingZerosFromPrice(currentText);
          if (currentText !== formattedText) {
            element.textContent = formattedText;
          }
        });
      }, 100); // Small delay to ensure DOM has updated
    });

    // Listen for cart drawer open event
    document.addEventListener('theme:cart-drawer:open', function() {
      setTimeout(function() {
        const cartTotalElements = document.querySelectorAll('[data-cart-total-price]');
        cartTotalElements.forEach(element => {
          const currentText = element.textContent.trim();
          const formattedText = removeTrailingZerosFromPrice(currentText);
          if (currentText !== formattedText) {
            element.textContent = formattedText;
          }
        });
      }, 200); // Small delay for drawer animation
    });
  }

  // Initialize the formatter
  initCartTotalFormatter();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
